/* @ngInject */
export default class BatteryStateFilterController {
    constructor($scope, currentFilter, onUpdate, onClose) {
        this.$scope = $scope;
        this.selectedValue = currentFilter || 'CRITICAL';
        this.onUpdate = onUpdate;
        this.onClose = onClose;
    }

    $onInit() {
        // Controller initialized with selectedValue from parent
    }

    clear() {
        this.selectedValue = null;
        this.apply();
    }

    apply() {
        this.onUpdate(this.selectedValue);
        this.onClose();
    }
}
